import { atom } from "jotai";
import type { RefObject } from "react";

export const whyRegisterHomepagePositionTriggerReferenceAtom =
  atom<null | RefObject<Element | null>>(null);

export const shouldShowMostPopularTagAtom = atom<boolean | null>(null);
